import React from 'react';

const Vehicles = () => {
  return (
    <div id="vehicles-return">
      <div id="vehicles-container">
        <div className="vehicle">
          One
        </div>
        <div className="vehicle">
          Two
        </div>
        <div className="vehicle">
          Three
        </div>
        <div className="vehicle">
          Four
        </div>
        <div className="vehicle">
          Five
        </div>
        <div className="vehicle">
          Six
        </div>
        <div className="vehicle">
          Seven
        </div>
      </div>
    </div>
  )
}

export default Vehicles;